// extracted by mini-css-extract-plugin
export default {"productCarousel":"t4-z"};